module.exports = __webpack_public_path__ + "static/media/icon-entregas.394adec2.svg";